import React from "react";
import { createRoot } from "react-dom/client";
import { init } from "@fullstory/browser";
import { PostHogProvider } from "posthog-js/react";
import App from "./App";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";
import { ClerkProvider } from "@clerk/clerk-react";
import { Toaster } from "./components/ui/toaster";
import { initGlobalErrorHandlers } from "./lib/error-reporting";

import "./lib/i18n"; // initialize i18next before any component renders
import "./index.css";

// Report uncaught errors and unhandled rejections through the error funnel
initGlobalErrorHandlers();

// Add posthog to the window so the posthog toolbar can render
import { posthog } from "posthog-js";
(window as any).posthog = posthog;

// Initialize FullStory
const FULLSTORY_ORG_ID = import.meta.env.VITE_FULLSTORY_ORG_ID;
if (FULLSTORY_ORG_ID) {
  init({ orgId: FULLSTORY_ORG_ID });
}

// Get the publishable key from environment variables
const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
        <PostHogProvider
          apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
          options={{
            api_host: "https://us.i.posthog.com",
            defaults: "2025-05-24",
            capture_exceptions: false, // Sentry owns exception capture; PostHog is for product analytics
          }}
        >
          <App />
          <Toaster />
        </PostHogProvider>
      </ClerkProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
